(() => {

    document.addEventListener('alpine:init', (e) => {
      // Linked Products variant switching
      Alpine.data('LinkedProducts', (type) => ({
        linkedProductsType: '',
        $section: null,
        $products: [],
        products: [],
        init() {
          let am = this;
          am.linkedProductsType = type;
  
          document.addEventListener('init-LinkedProducts', (e) => {
            if (am.$section) return;
  
            am.$section = e.target;
            am.$products = [...am.$section.querySelectorAll('[data-linked-product]')];
  
            // init products on page load
            (async() => {
              let px_products = am.$products.map(($item) => {
                let handle = $item.dataset.linkedProduct;
                return fetch(`/products/${ handle }.js`).then(res => res.json());
              });
  
              am.products = await Promise.all(px_products);
              am.UpdateLinkedProductUrls();
            })();
          });
  
          // on variant change, update linked produt urls
          document.addEventListener('variant:change', (e) => {
            am.UpdateLinkedProductUrls(e.detail.variant.options);
          });
        },
  
        UpdateLinkedProductUrls(current_values) {
          let am = this;
  
          if (!am.products.length) return;
  
          am.$products.forEach(($product) => {
            let handle = $product.dataset.linkedProduct;
            let product = am.products.find(p => p.handle == handle);
  
            if (!product) return;
  
            if (!current_values) {
              current_values = JSON.parse($product.dataset.current_values);
            }
  
            let optionIdsToMatch = [1,2,3];
            if (am.linkedProductsType) {
              // exclude option from matching
              optionIdsToMatch = optionIdsToMatch.filter((id) => product.options.map(opt => opt.name).indexOf(am.linkedProductsType) !== (id - 1));
            }
  
            let valuesToMatch = optionIdsToMatch.map((id) => current_values[(id-1)]);
      
            let matching_variant = product.variants.find((v) => {
              let v_options = optionIdsToMatch.map((id) => v[`option${ id }`]).join('/');
              return v_options == valuesToMatch.join('/')
            });
            if (!matching_variant) return;
            $product.setAttribute('href', `/products/${ handle }?variant=${ matching_variant.id }`);
  
            // apply soldout class if not available
            $product.querySelector('label').classList.toggle('disabled', !(matching_variant && matching_variant.available));
          });
        }
       }));
    });
  
  })();
  const GetCart = async () => {
    return await fetch('/cart.js').then(res => res.json());
  }
  
  const ConvertStringToHTML = (str) => {
    let parser = new DOMParser();
    let doc = parser.parseFromString(str, 'text/html');
    return doc.body;
  }
  
  const AddItemsToCart = (itemsToAdd) => {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ items: itemsToAdd })
    });
  }
  
  const UpsellProducts = (() => {
    return () => {
      return {
        $upsells: null,
        products: [],
        pageIndex: 1,
    
        init() {
          let inst = this;
          
          let $upsells = document.querySelector('.upsell__items');
          inst.$upsells = $upsells;
  
          // move quickshop modals to body
          inst.MoveModals();
  
          // on cart updated
          document.addEventListener('cart:rebuilt', (e) => {
            inst.ToggleUpsellItems();
          });
  
          inst.ToggleUpsellItems();
        },
  
        MoveModals() {
          let inst = this;
          inst.$upsells.querySelectorAll('.modal').forEach((modal) => {
            document.body.insertAdjacentElement('beforeend', modal);
          });
        },
  
        ToggleUpsellItems() {
          let inst = this;
          (async() => {
            let cart = await GetCart();
            let cart_product_ids = cart.items.map(item => `${item.product_id}`);
            inst.$upsells.querySelectorAll('.product-item').forEach(($item) => {
              let showProduct = cart_product_ids.indexOf($item.dataset.productId) == -1;
              $item.classList.toggle('hide', !showProduct);
            });
  
            // load more if all in cart
            let visible_count = inst.$upsells.querySelectorAll('.product-item:not(.hide)').length;
            if (visible_count == 0) {
              inst.LoadMoreUpsells();
            }
          })();
        },
  
        LoadMoreUpsells() {
          let inst = this;
          inst.pageIndex += 1;
  
          (async() => {
            let text = await fetch(`/cart?view=upsells-raw&page=${ inst.pageIndex }`).then(res => res.text());
            let html = ConvertStringToHTML(text);
            html.querySelectorAll('.product-item').forEach(($product) => {
              inst.$upsells.insertAdjacentElement('beforeend', $product);
            });
            inst.MoveModals();
            inst.ToggleUpsellItems();
          })();
        },
  
        AddItemToCart(id) {
          (async() => {
            let add_req = await AddItemsToCart([{id: id, quantity: 1}]);
            if (add_req.ok) {
              document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
                detail: {}
              }));    
            }
          })();
        }
      }
    }
  })();